import { DownOutlined, IdcardOutlined, UserOutlined } from '@ant-design/icons'
import { Col, DatePicker, Form, Input, Row, Select, Switch } from 'antd'
import { handleKeyAmount, handleKeyDownThree } from 'features/events/utils'
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator'
import { SetStateAction, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CouponFormField } from './types'
import { useGetDropDownCommonCoupon } from 'features/events/use-cases/get-coupon-common'

const AddCouponForm = ({ couponEditData, form, id,setIsSingleUse,isSingleUse }: { couponEditData: any; form: any, id: any,setIsSingleUse:any,isSingleUse:any }) => {
    const { t } = useTranslation();
    
    const valueType = [
        { value: 1, label: 'Flat' },
        { value: 2, label: 'Percent' },
    ];
    const couponType = [
        { value: "1", label: 'Automatic' },
        { value: "2", label: 'Manual' },
    ];
    const { data: EventCategoryData,} =
        useGetDropDownCommonCoupon({ Flag: "ACTIVE_CATEGORY", SearchValue: id });
    const validateValue = (_: any, value: number) => {
        const selectedValueType = form.getFieldValue(CouponFormField.ValueType);
        if (selectedValueType === 2 && value > 100) {

            return Promise.reject(new Error('Value cannot be more than 100 when ValueType is Percent'));
        }

        return Promise.resolve();
    };

    const [couponTypeVal, setCouponTypeVal] = useState(null);

    const handleCouponTypeChange = (value: SetStateAction<null>) => {
        setCouponTypeVal(value);
    };

    useEffect(() => {
        if (couponEditData) {
            setCouponTypeVal(couponEditData.coupon_type);
        }
    }, [couponEditData])

    return (
        <div className='frmscrll'>
            <FormSectionsSeparator title={""}>
                {!couponEditData?.id && <Form.Item<CouponFormField>
                    label={"Coupon Type"}
                    name={CouponFormField.CouponType}
                    rules={[
                        {
                            required: true,
                            // whitespace: true,
                            message: t('validateMessages.custom.nomsg'),
                        },
                    ]}
                >
                    <Select
                        options={couponType}
                        placeholder={"select coupon type"}
                        className='has-prefix-icon'
                        onChange={handleCouponTypeChange}
                        suffixIcon={
                            <>
                                <IdcardOutlined className='prefix-icon' />
                                <DownOutlined className='suffix-icon' />
                            </>
                        }
                    />
                </Form.Item>}
                <Form.Item label="Event Category" name="EventCategoryId">
                    <Select
                        showSearch
                        placeholder="Select Category"
                        optionFilterProp="label"
                        disabled={couponEditData}
                        filterOption={(input, option) =>
                            String(option?.label)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        // options={EventCategoryData?.DropDownData?.map((item: any) => ({
                        //     value: item.Id,
                        //     label: item.Title, // string
                        // }))}
                         options={[
                                { value: null, label: "All" }, // 👈 Add this
                                ...(EventCategoryData?.DropDownData?.map((item: any) => ({
                                    value: item.Id,
                                    label: item.Title,
                                })) || []),
                            ]}
                    />
                </Form.Item>

                <Form.Item<CouponFormField>
                    label={"Coupon Title"}
                    name={CouponFormField.Title}

                    rules={[
                        {
                            required: true,
                            // whitespace: true,
                            message: t('validateMessages.custom.nomsg'),
                        },
                    ]}
                >
                    <Input
                        placeholder={"Title"}
                        prefix={<UserOutlined className='input-prefix-icon' />}
                    />
                </Form.Item>



                {(!couponTypeVal || couponTypeVal != "2") &&
                    <Form.Item<CouponFormField>
                        label={"Prefix"}
                        name={CouponFormField.Prefix}

                        rules={[
                            {
                                required: true,
                                // whitespace: true,
                                message: t('validateMessages.custom.nomsg'),
                            },
                            {
                                min: 2,
                                max: 2,
                                message: 'Prefix must be exactly 2 characters long',
                            },
                        ]}
                    >
                        <Input
                            placeholder={"Prefix"}
                            maxLength={2}
                            disabled={couponEditData?.id}
                        />
                    </Form.Item>}
                <Form.Item label="Coupon Usage" name="isUsagePerUser" valuePropName="checked">
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <Switch
                            checked={isSingleUse}
                            disabled={couponEditData}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            onChange={(checked) => {
                                setIsSingleUse(checked);
                                form.setFieldValue("isUsagePerUser", checked);
                            }}
                        />

                        <span style={{ fontWeight: 500 }}>
                            {isSingleUse ? "Single Use" : "Multiple Use"}
                        </span>
                    </div>
                </Form.Item>
                {couponEditData?.id &&
                    <Form.Item<CouponFormField>
                        label={"Coupon Code"}
                        name={CouponFormField.couponCode}

                    // rules={[
                    //     {
                    //         required: true,
                    //         // whitespace: true,
                    //         message: t('validateMessages.custom.nomsg'),
                    //     },
                    // ]}
                    >
                        <Input
                            placeholder={""}
                            disabled={couponEditData?.id}
                        />
                    </Form.Item>
                }

                <Row gutter={16} style={{margin:0}}>

                    {/* No of Coupons */}
                    {(!couponEditData?.id && couponTypeVal != "2") && (
                        <Col span={12}>
                            <Form.Item<CouponFormField>
                                label="No of Coupons"
                                name={CouponFormField.NoOfCoupons}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="No of coupons"
                                    onKeyDown={handleKeyDownThree}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {/* Limit Usage */}
                    {!couponEditData?.id && (
                        <Col span={12}>
                            <Form.Item<CouponFormField>
                                label="Limit Usage"
                                name={CouponFormField.Limit}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Limit Usage"
                                    onKeyDown={handleKeyDownThree}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {/* Value Type */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="Value Type"
                            name={CouponFormField.ValueType}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <Select
                                options={valueType}
                                placeholder="Select Value type"
                                className="has-prefix-icon"
                                suffixIcon={
                                    <>
                                        <IdcardOutlined className="prefix-icon" />
                                        <DownOutlined className="suffix-icon" />
                                    </>
                                }
                            />
                        </Form.Item>
                    </Col>

                    {/* Value */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="Value"
                            name={CouponFormField.Value}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                                {
                                    validator(_, value) {
                                        if (!value) return Promise.resolve();
                                        const stringValue = String(value);
                                        const parsedValue = stringValue.match(/^\d*\.?\d{0,3}$/);
                                        
return parsedValue
                                            ? Promise.resolve()
                                            : Promise.reject(
                                                new Error(
                                                    'Please enter a valid numeric value with at most three decimal places'
                                                )
                                            );
                                    },
                                },
                                {
                                    validator: validateValue,
                                },
                            ]}
                        >
                            <Input
                                placeholder="Value"
                                onKeyDown={handleKeyAmount}
                            />
                        </Form.Item>
                    </Col>

                    {/* Start Date */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="Start Date"
                            name={CouponFormField.StartDate}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format="DD-MM-YYYY"
                            />
                        </Form.Item>
                    </Col>

                    {/* End Date */}
                    <Col span={12}>
                        <Form.Item<CouponFormField>
                            label="End Date"
                            name={CouponFormField.EndDate}
                            rules={[
                                {
                                    required: true,
                                    message: t('validateMessages.custom.nomsg'),
                                },
                            ]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format="DD-MM-YYYY"
                            />
                        </Form.Item>
                    </Col>

                </Row>


            </FormSectionsSeparator>
        </div>
    )
}

export default AddCouponForm;
